var render, staticRenderFns
import script from "./designer.vue?vue&type=script&lang=js"
export * from "./designer.vue?vue&type=script&lang=js"
import style0 from "./designer.vue?vue&type=style&index=0&id=26320e14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26320e14",
  null
  
)

export default component.exports